import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorSelectPopup from "./PapersGeneratorSelectPopup";
import PapersGeneratorSelectFilesPopup from "./PapersGeneratorSelectFilesPopup";
import Endpoints from "constants/Endpoints";
import PropTypes from "prop-types";
import useSnackbar from "hooks/useSnackbar";

const PapersGeneratOfferFilesVerification = (
    {
        demandId,
        paper,
        onClose,
        shareSystem
    }) => {

    const [invitedSuppliers, setInvitedSuppliers] = useState(null);
    const [chosenSupplier, setChosenSupplier] = useState(null);
    const [requestPositions, setRequestPositions] = useState(null);
    const [working, setWorking] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();

    const onSelectSupplier = (supplier) => {
        setChosenSupplier(supplier);
        PapersGeneratorService.getRfxSupplierAttachmentsVerification(demandId, supplier.id).then(resp => setRequestPositions(resp));
    }

    const onBack = () => {
        setChosenSupplier(null);
        setRequestPositions(null);
    }

    useEffect(() => {
        PapersGeneratorService.getRfxInvitedSupplierWithOffer(demandId).then(resp => setInvitedSuppliers(resp));
    }, [demandId])


    const generateClick = (selectedPos) => {
        setWorking(true);
        const url = Endpoints.PAPERS_GENERATOR_DEMAND_ATTACHMENT_VERIFICATION_REPORT(demandId) + `?supplierId=${chosenSupplier.id}&positionIds=${selectedPos.join(",")}`;

        if (shareSystem) {
            PapersGeneratorService.sharePaperByUrl(url, shareSystem).then(resp => resp ? enqueueSuccessSnackbar(Tr("int_upload_success_x", {x: shareSystem}, true)) : null).finally(() => setWorking(false));;
        } else {
            PapersGeneratorService.downloadPaper(url, () => setWorking(false), () => setWorking(false))
        }

    }

    return (<>
        {!chosenSupplier ?
            <PapersGeneratorSelectPopup onClose={onClose} paperId={paper.paperId} title={Tr('choose_supplier')} list={invitedSuppliers}
                                        onSelect={onSelectSupplier}/>
            : <PapersGeneratorSelectFilesPopup
                onClose={onClose}
                onGenerate={generateClick}
                paperId={paper.paperId}
                title={Tr('choose_position')}
                list={requestPositions} onBack={onBack}
                working={working}
            />
        }
    </>)
}


PapersGeneratOfferFilesVerification.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}

export default PapersGeneratOfferFilesVerification;